import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=bf7535e2"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/checkout-webapp-v2/checkout-webapp-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf7535e2')) {
      api.createRecord('bf7535e2', component.options)
    } else {
      api.reload('bf7535e2', component.options)
    }
    module.hot.accept("./Address.vue?vue&type=template&id=bf7535e2", function () {
      api.rerender('bf7535e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/address/Address.vue"
export default component.exports